import React, { useEffect, useState } from "react"
import ProfileTabs from "../components/ProfileTabs"
import { userAtom } from "../store"
import { useAtom } from "jotai"
import { getListingsByUserId } from "../firebase/listings"
import { formatDate } from "../utils"
import { Link } from "react-router-dom"
import Pagination from "../components/commons/Pagination"
import ProfileTitle from "../components/ProfileTitle"
import DialogDeclinedReason from "../components/dialogs/DialogDeclinedReason"

const MyListingsPage = () => {
    const [userData,] = useAtom(userAtom)
    const [items, setItems] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [currentMobilePage, setCurrentMobilePage] = useState(1)
    const itemsPerPage = 4
    const [showDeclinedReasonDialog, setShowDeclinedReasonDialog] = useState(false)
    const [selectedDeclinedReason, setSelectedDeclinedReason] = useState("")
    const [selectedListingTitle, setSelectedListingTitle] = useState("")

    const fields = ["Title", "Date Published", "Listing Price", "Available Amount", "Status", "Declined Reason"]

    useEffect(() => {
        if (userData && userData.id) {
            updateData()
        }
    }, [userData])

    const updateData = () => {
        getListingsByUserId(userData.id).then(data => {
            setItems(data)
        })
    }

    const handleViewDeclinedReason = (reason, title) => {
        setSelectedDeclinedReason(reason)
        setSelectedListingTitle(title)
        setShowDeclinedReasonDialog(true)
    }

    return (
        <div>
            <ProfileTitle />

            <ProfileTabs activeTab="Your Listings" />

            {
                items.length > 0 ?
                    <>
                        <div className="max-lg:hidden">
                            <div className="w-full overflow-auto">
                                <table className="w-full">
                                    <thead>
                                        <tr className="bg-[#2E2E2E] border-[1px] border-gray py-3 text-sm text-[#717171]">
                                            {
                                                fields.map((item, index) =>
                                                    <th className={`py-3 text-left ${index > 0 ? '' : 'pl-3'}`} key={`offer-field-${item}`}>
                                                        {item}
                                                    </th>
                                                )
                                            }
                                        </tr>
                                    </thead>

                                    <div className="pt-1" />
                                    <tbody className="text-white space-y-1 text-sm">
                                        {
                                            items.slice(itemsPerPage * (currentPage - 1), itemsPerPage * currentPage).map((item, index) =>
                                                <tr key={`offer-item-sent-${currentPage}-${item.title}-${index}`} className="border-[1px] border-gray text-nowrap">
                                                    <td className="py-2 pl-3 pr-20 lg:min-w-[400px] min-w-[200px]">
                                                        <div className="flex items-center">
                                                            <img
                                                                src={item.pictures[0]}
                                                                alt="picture"
                                                                className="w-[50px] h-[50px] mr-6 border-[1px] border-gray"
                                                            />

                                                            <span className="uppercase text-sm">
                                                                {item.title}
                                                            </span>
                                                        </div>
                                                    </td>

                                                    <td className="lg:min-w-[200px] pr-10">
                                                        {formatDate(item.created_at.seconds)}
                                                    </td>

                                                    <td className="lg:min-w-[200px] pr-10">
                                                        $ {item.price.toFixed(2)}
                                                    </td>

                                                    <td className="lg:min-w-[200px] pr-10">
                                                        {item.quantity}
                                                    </td>

                                                    <td className="pr-3">
                                                        <div className="flex items-center">
                                                            {
                                                                item.state === 'approved' ?
                                                                    <Link
                                                                        className="solo-button flex items-center justify-center mr-8 text-white border-white border-[1px] bg-primary w-[170px] h-[45px]" to={`/marketplace/${item.id}`}
                                                                    >
                                                                        View Listing
                                                                    </Link> :
                                                                    item.state === 'pending' ?
                                                                        <div
                                                                            className="flex items-center justify-center mr-8 text-white border-white border-[1px] bg-[#2A2A2A] w-[170px] h-[45px]"
                                                                        >
                                                                            Pending Approval
                                                                        </div> :
                                                                        <div
                                                                            className="flex items-center justify-center mr-8 text-[#5D5D5D] border-[#575757] border-[1px] bg-[#2A2A2A] w-[170px] h-[45px]"
                                                                        >
                                                                            Listing Declined
                                                                        </div>
                                                            }

                                                            <Link to={`/marketplace/edit-listing/${item.id}`}>
                                                                <img src="/assets/icons/icon-edit.svg" alt="edit" />
                                                            </Link>
                                                        </div>
                                                    </td>

                                                    <td className="pr-3">
                                                        {item.state === 'declined' && item.declined_reason ? (
                                                            <div className="flex flex-col gap-2">
                                                                <div 
                                                                    className="text-xs text-red-400 max-w-[200px]"
                                                                >
                                                                    {item.declined_reason.length > 80 
                                                                        ? `${item.declined_reason.substring(0, 80)}...` 
                                                                        : item.declined_reason
                                                                    }
                                                                </div>
                                                                <button
                                                                    onClick={() => handleViewDeclinedReason(item.declined_reason, item.title)}
                                                                    className="text-xs text-blue-400 hover:text-blue-300 underline cursor-pointer"
                                                                >
                                                                    View Full Reason
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="text-xs text-gray-500">
                                                                —
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div >

                            <div className="mt-9">
                                <Pagination itemsPerPage={itemsPerPage} totalItems={items.length} onPageChange={(value) => setCurrentPage(value)} />
                            </div>
                        </div>



                        <div className="lg:hidden">
                            <div className="grid sm:grid-cols-2 grid-cols-1 gap-5">
                                {
                                    items.slice(3 * (currentMobilePage - 1), 3 * currentMobilePage).map(item =>
                                        <div className="p-[10px] border-[1px] border-gray bg-[#191919]" key={item.id}>
                                            <div className="flex w-full">
                                                <img src={item.pictures[0]} className="w-[113px] h-[113px] object-cover bg-white border-[1px] border-gray mr-4" alt="image" />

                                                <div className="w-full mb-9">
                                                    <div className="uppercase text-white text-sm">{item.title}</div>

                                                    <div className="mt-3 w-full flex justify-between text-[#717171] text-xs">
                                                        <span>Listing Price</span>
                                                        <span className="text-white">$ {item.price.toFixed(2)}</span>
                                                    </div>

                                                    <div className="mt-4 w-full flex justify-between text-[#717171] text-xs">
                                                        <span>Available Amount</span>
                                                        <span className="text-white">{item.quantity}</span>
                                                    </div>

                                                    <div className="mt-3 w-full flex justify-between text-[#717171] text-xs">
                                                        <span>Published</span>
                                                        <span className="text-white">{formatDate(item.created_at.seconds)}</span>
                                                    </div>

                                                    {item.state === 'declined' && item.declined_reason && (
                                                        <div className="mt-3 w-full">
                                                            <div className="flex justify-between text-[#717171] text-xs mb-1">
                                                                <span>Declined Reason</span>
                                                                <span className="text-red-400 text-right max-w-[120px]">
                                                                    {item.declined_reason.length > 30 
                                                                        ? `${item.declined_reason.substring(0, 30)}...` 
                                                                        : item.declined_reason
                                                                    }
                                                                </span>
                                                            </div>
                                                            <button
                                                                onClick={() => handleViewDeclinedReason(item.declined_reason, item.title)}
                                                                className="text-xs text-blue-400 hover:text-blue-300 underline cursor-pointer w-full text-right"
                                                            >
                                                                View Full Reason
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="w-full items-center">
                                                <Link to={`/marketplace/edit-listing/${item.id}`}
                                                    className="flex items-center justify-center w-full mb-2 text-sm text-white border-gray border-[1px] h-[40px]">
                                                    <img src="/assets/icons/icon-edit.svg" alt="edit" className="w-4 h-4 mr-1" />
                                                    Edit Listing
                                                </Link>

                                                {item.state === 'approved' ? (
                                                    <Link className="flex items-center justify-center text-sm mr-8 text-white border-white border-[1px] bg-primary w-full h-[40px]" to={`/marketplace/${item.id}`}>
                                                        View Listing
                                                    </Link>
                                                ) : item.state === 'pending' ? (
                                                    <div className="flex items-center justify-center text-sm mr-8 text-white border-white border-[1px] bg-[#2A2A2A] w-full h-[40px]">
                                                        Pending Approval
                                                    </div>
                                                ) : (
                                                    <div className="flex items-center justify-center text-sm mr-8 text-[#5D5D5D] border-[#575757] border-[1px] bg-[#2A2A2A] w-full h-[40px]">
                                                        Listing Declined
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                            </div>

                            <div className="mt-9">
                                <Pagination itemsPerPage={3} totalItems={items.length} onPageChange={(value) => setCurrentMobilePage(value)} />
                            </div>
                        </div>
                    </>
                    :
                    <div className="text-white text-lg text-center mt-8">
                        No listings you have uploaded
                    </div>
            }

            {/* Declined Reason Dialog */}
            <DialogDeclinedReason
                open={showDeclinedReasonDialog}
                onClose={() => setShowDeclinedReasonDialog(false)}
                listingTitle={selectedListingTitle}
                declinedReason={selectedDeclinedReason}
            />
        </div>
    )
}

export default MyListingsPage
